<!--if the mat-menu isn't here, the man-menu-items aren't styled nicely-->
<div role="toolbar">
  <a tabindex='-1' *ngFor='let report of reports'><img src='../images/document_empty.png'> {{report.RptTitle}}</a>
</div>
